import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useQuery } from "@tanstack/react-query";
import { requests } from "../../../services/http-common";
import {
    TJobFormData,
} from "../../Sales/Contracts/CreateJobAndSchedule/CreateJobAndSchedule.model";
import * as Yup from "yup";
import { IJobSchedule } from "../../../models/JobZone";

export function useScheduleFetch(scheduleId?: number) {
    const formSchema = Yup.object().shape({
        name: Yup.string().required("Field is required"),
        zoneCode: Yup.number().required("Field is required").nullable(true),
        employeeIds: Yup.array()
            .of(Yup.string())
            .min(1, "At least one employee should be selected"),
        supervisorIds: Yup.array().of(Yup.string()),
        additionalNotes: Yup.string(),
        startTime: Yup.date().required("Field is required").nullable(true),
        lateInAlertTime: Yup.number().required("Field is required").nullable(true),
        endTime: Yup.date().required("Field is required").nullable(true),
        lateOutAlertTime: Yup.number().required("Field is required").nullable(true),
        attachments: Yup.array().of(Yup.mixed())
    });

    const form = useForm<TJobFormData>({
        resolver: yupResolver(formSchema),
        shouldFocusError: false,
        defaultValues: {
            name: "",
            zoneCode: null,
            employeeIds: [],
            supervisorIds: [],
            additionalNotes: "",
            startTime: null,
            lateInAlertTime: null,
            endTime: null,
            lateOutAlertTime: null,
        },
    });

    const { data: scheduleData } = useQuery({
        queryKey: [`jobSchedule-${scheduleId}`],
        queryFn: () => {
            return requests.get(`/job/jobSchedule/${scheduleId}`);
        },
        onSuccess: (data: IJobSchedule) => {
            form.reset((values) => ({
                ...values,
                name: data.jobDetail.name,
                zoneCode: data.zoneCode,
                employeeIds: data.employees.map((e) => e.id),
                // The response's `supervisor` array is authoritative - seed it, or
                // the next save would send an empty list back.
                supervisorIds: (data.supervisor ?? []).map((s) => s.id),
                additionalNotes: data.jobDetail.additionalNotes,
                startTime: data.startTime,
                endTime: data.endTime,
                lateInAlertTime: data.lateInAlertTime,
                lateOutAlertTime: data.lateOutAlertTime,
                attachments: JSON.parse(data.jobDetail.attachment2Path).map((a: string) => ({ name: a.split("/").at(-1), path: a }))
            }));
        },
        refetchOnWindowFocus: false,
    });

    return { form, scheduleData }

}